var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: {
        value: true,
        size: "xl",
        title: "Link Layers to Auto-Fill Values",
      },
      on: { closed: _setup.closeModal },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "d-flex justify-content-between w-100" },
                [
                  _c(_setup.CButton, {
                    attrs: { text: "Cancel", variant: "secondary" },
                    on: { click: _setup.closeModal },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex" },
                    [
                      _vm.targetElement.sourceElement != null
                        ? _c(_setup.CButton, {
                            staticClass: "me-2",
                            attrs: { text: "Unlink", variant: "danger" },
                            on: { click: _setup.onUnlinkHandler },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(_setup.CButton, {
                        attrs: {
                          text: "Apply Link",
                          variant: "primary",
                          disabled: !_setup.canApplyLink,
                        },
                        on: { click: _setup.onConfirmHandler },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("p", { staticClass: "subtitle" }, [
        _vm._v(
          "Link layers to auto-fill their values, with inputs from other elements."
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "options-card" }, [
        _c("div", { staticClass: "form-group w-100" }, [
          _c("label", [_vm._v("Autofill Layer")]),
          _vm._v(" "),
          _c("div", { staticClass: "fake-input disabled-white" }, [
            _c("div", { staticClass: "source-option" }, [
              _c(
                "span",
                { staticClass: "source-badge" },
                [
                  _setup.targetIcon
                    ? _c(_setup.SvgIcon, {
                        staticClass: "source-icon",
                        attrs: { src: _setup.targetIcon },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "source-id" }, [
                    _vm._v(_vm._s(_vm.targetElement.id)),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "source-name" }, [
                _vm._v(_vm._s(_vm.targetElement.name)),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group w-100 d-flex gap-3" }, [
          _c(
            "div",
            { staticClass: "select-column" },
            [
              _c("label", [_vm._v("With Input from Layer")]),
              _vm._v(" "),
              _c(_setup.CSelect, {
                staticClass: "w-100",
                attrs: {
                  options: _setup.sources,
                  placeholder: "Select source",
                  "append-to-body": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "option",
                    fn: function (option) {
                      return [
                        _c("div", { staticClass: "source-option" }, [
                          _c(
                            "span",
                            { staticClass: "source-badge" },
                            [
                              _setup.getSourceIcon(option.value)
                                ? _c(_setup.SvgIcon, {
                                    staticClass: "source-icon",
                                    attrs: {
                                      src: _setup.getSourceIcon(option.value),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "source-id" }, [
                                _vm._v(
                                  _vm._s(_setup.getSourceId(option.value))
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "source-name" }, [
                            _vm._v(_vm._s(option.label)),
                          ]),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "selected-option",
                    fn: function (option) {
                      return [
                        _c("div", { staticClass: "source-option" }, [
                          _c(
                            "span",
                            { staticClass: "source-badge" },
                            [
                              _setup.getSourceIcon(option.value)
                                ? _c(_setup.SvgIcon, {
                                    staticClass: "source-icon",
                                    attrs: {
                                      src: _setup.getSourceIcon(option.value),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "source-id" }, [
                                _vm._v(
                                  _vm._s(_setup.getSourceId(option.value))
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "source-name" }, [
                            _vm._v(_vm._s(option.label)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _setup.selectedSource,
                  callback: function ($$v) {
                    _setup.selectedSource = $$v
                  },
                  expression: "selectedSource",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "select-column" },
            [
              _c("label", [_vm._v("With Value Format")]),
              _vm._v(" "),
              _c(_setup.CSelect, {
                staticClass: "w-100",
                attrs: {
                  options: _setup.valueFormats,
                  placeholder: "Select value format",
                  "append-to-body": true,
                },
                model: {
                  value: _setup.selectedValueFormat,
                  callback: function ($$v) {
                    _setup.selectedValueFormat = $$v
                  },
                  expression: "selectedValueFormat",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }